module.exports = __webpack_public_path__ + "img/cad9675.png";